/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useState } from 'react';
import { Box, Grid, useMediaQuery } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { LandingFooter } from '../../common';
import useLandingChart from '../../hooks/useLandingChart';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import PageLayout from './PageLayout';

import RefetchBox from '../../Shared/RefetchBox';
import {
  PercentTodayBox,
  TodayTotalEvents,
  TodayTotalSales,
} from '../../Sections/generator/page/boxs';

export default function EmpLanding(props: any) {
  const { words, isRTL, user, theme, menuitem, employeeId, sub } = props;
  const [time, setTime] = useState(null);
  const { height } = useWindowDimensions();

  const location = useLocation();
  const { chartData } = useLandingChart(employeeId);

  const isMobile = useMediaQuery('(max-width:600px)');

  const refresh = () => {
    if (chartData?.refetch) {
      chartData?.refetch();
    }
  };

  useLayoutEffect(() => {
    refresh();
  }, [location]);

  useEffect(() => {
    if (sub?.data?.eventChange?.time && sub?.data?.eventChange?.time !== time) {
      setTime(sub?.data?.eventChange?.time);
      refresh();
    }
  }, [sub]);
  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      user={user}
      theme={theme}
      refresh={refresh}
      loading={chartData?.loading}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
          backgroundColor: '#f5f5f5',
          marginLeft: 5,
          marginRight: 5,
        }}
      >
        {isMobile && (
          <Box
            style={{
              position: 'absolute',
              zIndex: 111,
              top: 60,
              left: isRTL ? 20 : undefined,
              right: isRTL ? undefined : 20,
            }}
          >
            <RefetchBox
              isRTL={isRTL}
              theme={theme}
              refresh={refresh}
              loading={chartData?.loading}
            ></RefetchBox>
          </Box>
        )}
        <Box
          style={{
            marginTop: 75,
            marginLeft: 10,
            marginRight: 10,
            marginBottom: 15,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TodayTotalEvents
                isRTL={isRTL}
                theme={theme}
                dark={null}
                color={null}
                systemcolor={null}
                height={100}
                employeeId={employeeId}
                isEmployee={true}
              ></TodayTotalEvents>
            </Grid>
            <Grid item xs={12} md={3}>
              <TodayTotalSales
                isRTL={isRTL}
                theme={theme}
                dark={null}
                color={null}
                systemcolor={null}
                height={100}
                employeeId={employeeId}
                isEmployee={true}
              ></TodayTotalSales>
            </Grid>
            <Grid item xs={12} md={3}>
              <PercentTodayBox
                isRTL={isRTL}
                theme={theme}
                color={null}
                height={220}
                systemcolor={null}
                employeeId={employeeId}
                isEmployee={true}
              ></PercentTodayBox>
            </Grid>
            {/* <Grid item xs={12} md={3}>
              <AppointmentIcon
                isRTL={isRTL}
                theme={theme}
                color={null}
                height={220}
                company={company}
                employeeId={employeeId}
              ></AppointmentIcon>
            </Grid> */}
            {/* <Grid item xs={12} md={3}>
              <InvoiceIcon
                isRTL={isRTL}
                theme={theme}
                color={null}
                height={220}
                company={company}
                employeeId={employeeId}
              ></InvoiceIcon>
            </Grid> */}
            {/* <Grid item xs={12} md={3}>
              <ReceiptIcon
                isRTL={isRTL}
                theme={theme}
                color={null}
                height={220}
                company={company}
                employeeId={employeeId}
              ></ReceiptIcon>
            </Grid> */}
          </Grid>
          <LandingFooter></LandingFooter>
        </Box>
      </Box>
    </PageLayout>
  );
}
